import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('HeaderContainer')(
  css({
    position: 'relative',
    backgroundColor: 'red',
    paddingY: 'default',
    paddingX: 'xl',
    color: 'white',
  }),
);

themeStyles.addBaseStyles('Title')(
  css({
    color: 'white',
    fontFamily: 'default',
    marginBottom: 'xs',
    width: ['90%', '100%'],
  }),
);

themeStyles.addBaseStyles('Description')(
  css({
    fontFamily: 'default',
    color: 'white',
  }),
);

themeStyles.addBaseStyles('CloseButton')(() =>
  css({
    position: 'absolute',
    backgroundColor: 'white',
    borderColor: 'transparent',
    borderRadius: '50%',
    padding: '1px',
    outline: 'none',
    cursor: 'pointer',
    width: '25px',
    height: '25px',
    right: '48px',
    top: '24px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    svg: {
      width: '12px',
      path: {
        stroke: 'red',
        strokeWidth: '2',
      },
    },
  }),
);

themeStyles.addBaseStyles('FormWrapper')(
  css({
    paddingY: 'zero',
    paddingX: 'default',
    my: 'l',
  }),
);

themeStyles.addBaseStyles('RequiredFieldsCopy')(
  css({
    paddingBottom: 's',
    fontStyle: 'italic',
  }),
);

themeStyles.addBaseStyles('PromotionCopy')(
  css({
    pt: ['default', 'l'],
    pb: ['none', 'm'],
    fontWeight: 'bold',
  }),
);

themeStyles.addBaseStyles('PrivacyContainer')(
  css({
    marginY: 'l',
    // only p with a preceding p will have a margin
    '& > p + p': {
      mt: 'm',
    },
  }),
);

themeStyles.addBaseStyles('StyledLabel')(
  css({
    fontSize: '14px',
  }),
);

themeStyles.addBaseStyles('FieldsContainer')(
  css({
    display: ['inline', 'flex'],
    gap: 'm',
  }),
);

themeStyles.addBaseStyles('StyledInput')(
  css({
    width: '100%',
    fontSize: '14px!important',
  }),
);

themeStyles.addBaseStyles('StyledSelect')(
  css({
    paddingY: '0',
    background: 'transparent',
    border: '1px solid grey',
    borderRadius: '3px',
    height: ['40px', '44px'],
    color: 'black',
    '> div': {
      backgroundColor: 'transparent',
      height: '100%',
      '&:after': {
        backgroundColor: 'transparent',
      },
      '> span': {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: ['100%', '140px'],
      },
    },
    ul: {
      textOverflow: 'hidden',
    },
    li: {
      width: '100%',
      display: 'block',
    },
  }),
);

themeStyles.addBaseStyles('InputWrapper')(
  css({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    mt: 'm',
  }),
);

themeStyles.addBaseStyles('StyledErrorLabel')(
  css({
    fontWeight: 'bold',
    pt: 'xxs',
    lineHeight: ['18px', '12px'],
  }),
);

themeStyles.addBaseStyles('FormSubmissionResultContainer')(
  css({
    display: 'flex',
    flexDirection: 'column',
    paddingY: 'default',
    paddingX: 'xl',
  }),
);

themeStyles.addBaseStyles('ExploreButton')(
  css({
    width: 'max-content',
  }),
);

export default themeStyles;
